module.exports = __webpack_public_path__ + "static/media/shop-fitter.28807a37.jpg";